<template>
	<div class="service-locations-general-card-edit">
		<label for="extendedServiceControl">
			<span>Extended Service Control</span>
		</label>
		<Toggle
			id="extendedServiceControl"
			v-model="localData.extendedServiceControl"
			:isLabelBefore="true"
		>
			<template slot="true-value">YES</template>
			<template slot="false-value">NO</template>
		</Toggle>
		<section>
			<h6>Default Account Codes</h6>
			<Dropdown
				label="Service"
				v-model="localData.defaultAccountCodes.service"
				:options="serviceTypeOptions"
			/>
			<Dropdown
				label="Body Shop"
				v-model="localData.defaultAccountCodes.bodyShop"
				:options="bodyShopTypeOptions"
			/>
			<Dropdown
				label="Quick Lube"
				v-model="localData.defaultAccountCodes.quickLube"
				:options="quickLubeTypeOptions"
			/>
		</section>
		<section>
			<h6>Default Inbound Account Codes</h6>
			<Dropdown
				label="Client Pay"
				v-model="localData.defaultInboundAccountCodes.customerPay"
				:options="customerPayTypeOptions"
			/>
			<Dropdown
				label="Internal"
				v-model="localData.defaultInboundAccountCodes.internal"
				:options="internalTypeOptions"
			/>
			<Dropdown
				label="Extended Service"
				v-model="localData.defaultInboundAccountCodes.extendedService"
				:options="extendedServiceTypeOptions"
			/>
			<Dropdown
				label="Warranty"
				v-model="localData.defaultInboundAccountCodes.warranty"
				:options="warrantyTypeOptions"
			/>
		</section>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import Toggle from '@/components/forms/selection-control/toggle/toggle';
import _ from 'lodash';

export default {
	name: 'PartsLocationsGeneralCardEdit',
	components: { Dropdown, Toggle },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			serviceTypeOptions: ['lorem', 'ipsum'],
			bodyShopTypeOptions: ['lorem', 'ipsum'],
			quickLubeTypeOptions: ['lorem', 'ipsum'],
			customerPayTypeOptions: ['lorem', 'ipsum'],
			internalTypeOptions: ['lorem', 'ipsum'],
			extendedServiceTypeOptions: ['lorem', 'ipsum'],
			warrantyTypeOptions: ['lorem', 'ipsum']
		};
	},
	created() {
		//console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.service-locations-general-card-edit {
	&__item {
		display: block;
	}
}
</style>
